export enum BranchOrientation {
  Vertical = "vertical",
  Horizontal = "horizontal",
}
